import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_AB_TEST } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteAbTest } from './types'

export const useDeleteAbTest = (): UseDeleteAbTest => {
  const { t } = useTranslation('features/abTests', {
    keyPrefix: 'list.actions.delete',
  })
  const { enqueueSnackbar } = useSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_AB_TEST,
    onCompleted: async (data: Data) => {
      const { errors } = data

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error'), { variant: 'success' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getAbTests'],
  })

  const deleteAbTest = (id: string): void => void mutateAsync({ input: { id } })

  return { deleteAbTest, loading }
}
